import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import useSubjectRestrictions from 'legacy/src/components/impersonating/hooks/useSubjectsRestrictions';
import useImpersonateModal from 'legacy/src/components/impersonating/hooks/useImpersonateModal';
import UnableToViewModal from 'legacy/src/components/impersonating/components/UnableToViewModal';
import {
  isImpersonatingSubjectAvailable,
  getUnableToViewContent,
} from 'legacy/src/components/impersonating/utils';

const ImpersonateSubjectSelector = (props) => {
  const {
    children,
    impersonating,
    apImpersonatingFlag,
    preapImpersonatingFlag,
    userData,
  } = props;
  const { teacherSubjects, subject = '0' } = impersonating || {};
  const [isImpersonatingReady, setIsImpersonatingReady] = useState(false);
  const [externalLinkModal, openExternalLinkModal] = useImpersonateModal({
    modal: UnableToViewModal,
  });
  const { studentSubjects } = userData;

  const [, setSubjectRestrictions] = useSubjectRestrictions({
    impersonating,
    studentSubjects,
    apImpersonatingFlag,
    preapImpersonatingFlag,
    userData,
    onRestrictedSubject: (messageType) => {
      const contentData = getUnableToViewContent(messageType);
      openExternalLinkModal(contentData);
    },
  });

  useEffect(() => {
    if (subject && (teacherSubjects || []).length) {
      const teacherSubject = teacherSubjects.find(({ id }) => id === subject);
      const { subjectProgram } = teacherSubject;
      if (
        isImpersonatingSubjectAvailable({
          program: subjectProgram,
          apImpersonatingFlag,
          preapImpersonatingFlag,
        })
      ) {
        setIsImpersonatingReady(true);
      }
    }
  }, [subject, teacherSubjects]);

  if (isImpersonatingReady) {
    return (
      <Fragment>
        {externalLinkModal}
        {React.cloneElement(children, {
          onSubjectClick: setSubjectRestrictions,
        })}
      </Fragment>
    );
  }

  return children;
};

ImpersonateSubjectSelector.propTypes = {
  impersonating: PropTypes.object,
};

export default ImpersonateSubjectSelector;
